/** Emails go to the API trimmed and in lowercase ("Ann@School.ORG " -> "ann@school.org") */
export const normalizeEmail = (email) =>
  typeof email === "string" ? email.trim().toLowerCase() : email;
